import React, { useState } from "react";
import { DeleteOutlineRounded } from "@mui/icons-material";
import { Box, IconButton, MenuItemProps, styled, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import DeleteDialog from "@common/components/Button/DeleteButton/dialog";
import { ControlsProps, TooltipButtonProps } from "./types";
import SelectField from "./SelectField";

export const LabelContainer = styled(Box)(() => ({
  "& > svg": { fontSize: "1rem", verticalAlign: "middle" },
}));

export const TooltipButton = (props: TooltipButtonProps) => {
  const { title = "", ...buttonProps } = props;
  const { t } = useTranslation();
  return (
    <Tooltip arrow title={t(title)}>
      <span>
        <IconButton {...buttonProps} />
      </span>
    </Tooltip>
  );
};

export const SortBySelect = <T extends MenuItemProps["value"]>(
  props: Pick<ControlsProps<T>, "onSelect" | "options" | "selected">
) => {
  const { t } = useTranslation();
  const label = t("Sort by");
  return <SelectField fullWidth label={label} {...props} />;
};

export const DeleteButton = (
  props: TooltipButtonProps & Pick<ControlsProps<any>, "DeleteDialogProps">
) => {
  const [open, setOpen] = useState<boolean>(false);
  const { onClick = () => {}, DeleteDialogProps, ...btnProps } = props;
  const handleClick = () =>
    DeleteDialogProps !== undefined ? setOpen(true) : onClick;
  const { actionLabel = "", confirmPrompt = "" } = DeleteDialogProps ?? {};
  return (
    <>
      <TooltipButton {...btnProps} onClick={handleClick}>
        <DeleteOutlineRounded />
      </TooltipButton>
      <DeleteDialog
        open={open}
        actionLabel={actionLabel}
        confirmPrompt={confirmPrompt}
        onConfirm={() => {
          setOpen(false);
          onClick();
        }}
        onClose={() => setOpen(false)}
      />
    </>
  );
};
